<script>
export default {

  name: 'Benefits',

  props: {
    benefits: {
      type: String,
      required: true
    },

    pricing: {
      type: Object,
      required: true
    }
  },

  computed: {
    items() {
      return [
        this.signup_fee_text(this.pricing),
        this.subscription_fee_text(this.pricing),
        ...this.benefits.split('\n')
      ]
    }
  },

  methods: {
    itemClass(index) {
      let offset = ''
      // add an offset if there's an odd number of items so they appear centered
      if (index == 0 && (24 / this.items.length) % 2 != 0) {
        offset = 'small-offset-2'
      }
      return `text-center float-left column ${offset} medium-${Math.floor(24 / this.items.length)} small-24`
    }
  }

}
</script>

<template>

  <div class="section-description">
    <div class="row">
      <div class="columns small-offset-1 small-22">
        <div class="row">

          <div :class="itemClass(index)" v-for="(item, index) in items" :key="index" v-html="item"></div>

        </div>
      </div>
    </div>
  </div>

</template>

<style lang="scss">

.section-description {
  padding: 20px 0;
  font-size: rem-calc(18);
  background-color: white;
}

</style>


// WEBPACK FOOTER //
// src/components/Benefits.vue